import React from 'react'
import {
    Flex,
    Icon,
    IconProps,
    Tooltip,
    Text,
    TextProps,
    FlexProps,
    StackProps,
} from '@chakra-ui/react'
import { IoMdInformationCircleOutline } from 'react-icons/io'
import SharedStack from './wrappers/shared-stack'

interface Props extends IconProps {
    tooltip: React.ReactNode
    label?: string
    labelProps?: TextProps
    containerProps?: StackProps
}

export default function InfoTooltip({
    label,
    tooltip,
    labelProps,
    containerProps,
    ...props
}: Props) {
    return (
        <Tooltip label={tooltip} fontSize="xs" placement="top">
            <span>
                <SharedStack row spacing={1} align="center" {...containerProps}>
                    {!!label && <Text {...labelProps}>{label}</Text>}
                    <Icon
                        as={IoMdInformationCircleOutline}
                        color="gray.500"
                        {...props}
                    />
                </SharedStack>
            </span>
        </Tooltip>
    )
}
